import kambiSportsTable from '../../../../shared/pkg/prepacks/kambiSports.json'

const SPORT_WORD_SEPARATOR_PATTERN = /[_\s-]+/
const WHITESPACE_RUN_PATTERN = /\s+/g

/**
 * Every Kambi sport id (Kambi's documented list; new ones appear), with its
 * label and, where Prepacks has one, the builder sport a schedule saves for
 * it (`football` is American football, `soccer` is Kambi's FOOTBALL). One
 * table, kambiSports.json, beside the other Prepacks tables; Go's
 * kambi_sports_test.go checks it against the server's SportKey.
 */
export const KAMBI_SPORTS = Object.freeze(kambiSportsTable.kambi_sports.map((sport) => Object.freeze({ ...sport })))

const SPORT_LABELS = Object.freeze({ ...kambiSportsTable.sport_labels })
const BY_ID = new Map(KAMBI_SPORTS.map((sport) => [sport.id, sport]))

const SMALL_WORDS = new Set(['of', 'the', 'and', 'a', 'on'])

// A label for an id the table doesn't know yet: "WINTER-XGAMES" reads
// "Winter Xgames", "SOME_NEW_SPORT" reads "Some New Sport".
function labelFromId(id) {
  return String(id ?? '')
    .split(SPORT_WORD_SEPARATOR_PATTERN)
    .filter(Boolean)
    .map((word, index) => {
      const lower = word.toLowerCase()
      return index > 0 && SMALL_WORDS.has(lower) ? lower : lower.charAt(0).toUpperCase() + lower.slice(1)
    })
    .join(' ')
}

/** The label of a Kambi sport id ("RUGBY_UNION" is "Rugby Union"); an unknown id reads as its words. */
export function kambiSportLabel(id) {
  const key = String(id ?? '').trim().toUpperCase()
  return BY_ID.get(key)?.label || labelFromId(id)
}

/** The builder sports, in the order the table lists their labels. */
export const PREPACK_SPORTS = Object.freeze(Object.keys(SPORT_LABELS))

/**
 * The label of a sport a schedule saved: a builder sport by its table label
 * ("hockey" is "Ice Hockey"), else a Kambi sport id or any other token by its
 * words ("darts" is "Darts").
 */
export function prepackSportLabel(sport) {
  const key = String(sport ?? '').trim().toLowerCase()
  if (Object.hasOwn(SPORT_LABELS, key)) return SPORT_LABELS[key]
  return kambiSportLabel(sport)
}

/** The builder sport a Kambi sport id stands for ("ICE_HOCKEY" is `hockey`), else null. */
export function kambiSportOf(id) {
  const key = String(id ?? '').trim().toUpperCase().replace(WHITESPACE_RUN_PATTERN, '_')
  return BY_ID.get(key)?.sport || null
}

/** The Kambi sports filed under a builder sport (`rugby`: Rugby Union, Rugby League). */
export function kambiSportsFor(sport) {
  const key = String(sport ?? '').trim().toLowerCase()
  return KAMBI_SPORTS.filter((entry) => entry.sport === key)
}
